import React, { useEffect, useState } from "react";
import './Warning.css'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import warning from '../../../../assets/images/warning.png'
import { useTranslation } from "react-i18next";
import { AbstructVar } from "../abstruct-component/AbstructVar";

function Warning({ loadDel, arr, open, setOpen, handleDelete }) {
    let { mode } = AbstructVar()
    const [t, i18n] = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);

    const mainDelete = async () => {
        try {
            setIsDeleting(true); // بداية الحذف
            await handleDelete(arr.id);
        } catch (error) {
            // يمكنك إدراج معالجة الأخطاء هنا
        } finally {
            setIsDeleting(false); // انتهاء الحذف
        }
    }

    useEffect(() => {
        i18n.changeLanguage(localStorage.getItem('pentalensLang'));
    }, []);

    useEffect(() => {
        if (loadDel !== isDeleting && !loadDel && isDeleting) {
            setOpen(false); // إغلاق البوب اب عند اكتمال الحذف
        }
    }, [loadDel, isDeleting, setOpen]);


    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center
            classNames={{
                modal: `popupWarning ${mode === 'dark' ? "darkPopUp" : "lightPopUp"}`,
            }}
            focusTrapped={false}
        >
            <div className="warning">
                <img src={warning} alt="Warning" />
                <span className={mode === 'dark' ? "darktext" : "lighttext"} >{t('sure')}</span>
                <div className="btn_warning">
                    <button onClick={mainDelete} className="yes" disabled={loadDel}>
                        {loadDel ? " Loading ..." : `${t('yes')}`}
                    </button>
                    <button onClick={() => setOpen(false)} className="no" disabled={loadDel}>{t('cancel')}</button>
                </div>
            </div>
        </RModal>
    )
}

export default Warning;